export default __webpack_public_path__ + "static/media/H1001.4.ddc7a6ef.mp3";